import type { UserAuthRole } from '@/client/services/userRole/types'

import getUserRoles from './getUserRoles'
import type { UserLike } from './types'

// The reason this function exists, and we just don't call
// .includes() on user.roles directly is because it resolves
// the hierarchy before checking
export default function hasUserRole(user: UserLike, role: UserAuthRole): boolean {
  return getUserRoles(user).includes(role)
}
